import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {getUserWorkspaceSettings, setUserWorkspaceSettings} from 'src/openapi/admin/apis/UsersWorkspaceSettingsApi';
import {useAppDispatch} from 'src/store/hooks';

import type {SaveOptions} from 'src/components/save-with-reason/save-with-reason-button';
import type {WorkspaceSettings} from 'src/openapi/admin/models/WorkspaceSettings';

type Props = {
    userId: number,
};

export const useWorkspaceSettings = ({userId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => apiDispatch(
        getUserWorkspaceSettings({userId}),
    ), [userId, apiDispatch]);

    const saveDispatchAction = useCallback((
        workspaceSettings: WorkspaceSettings,
        signal: AbortSignal,
        options?: SaveOptions,
    ) => apiDispatch(
        setUserWorkspaceSettings({
            userId,
            userWorkspaceSettingsSaveRequest: {...workspaceSettings, reason: options?.reason},
        }, {signal}),
    ), [userId, apiDispatch]);

    return useCommonDataHook({
        initValue: {
            publishAllowed: false,
        },
        getDispatchAction,
        saveDispatchAction,
    });
};
